import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './NewTrip.css';
import Aux from '../../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../Backdrop/Backdrop';
import carImg from '../../../assets/images/car-icon.png';
import closeImg from '../../../assets/images/close-icon.png';
import saveImg from '../../../assets/images/save-icon.png';
import routeIconImg from '../../../assets/images/route-white-icon.png';
import Icon from '../Icon/Icon';
import ButtonIcon from '../ButtonIcon/ButtonIcon';
import Input from '../Input/Input';
import logError from '../../../store/LogError';
import axios from '../../../axios-trips';
import * as actionTypes from '../../../store/actions';

class CardModal extends Component {

  createInputConfig = (elementType,
    elementConfig,
    label,
    value = '',
    validation = {},
    valid = true,
    extraClass = null,
    extraAction = null) => {
    return ({
      elementType: elementType,
      elementConfig: elementConfig,
      label: label,
      value: value,
      validation: validation,
      valid: valid,
      extraClass: extraClass,
      extraAction: extraAction,
      touched: false,
      errorMessage: null
    });
  }

  getTodayDate() {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate());
    let date = tomorrow.getFullYear() + "-";
    if (tomorrow.getMonth() < 10) {
      date += "0";
    }
    date += (tomorrow.getMonth() + 1) + "-";
    if (tomorrow.getDate() < 10) {
      date += "0"
    }
    date += tomorrow.getDate();
    return date;
  }

  createLocations() {
    let formattedLocations = [];
    const locations = Object.values(this.props.locations);
    locations.sort(function (a, b) {
      if (a.region > b.region) {
        return 1;
      } else if (a.region === b.region) {
        return a.locationName > b.locationName ? 1 : -1;
      } else {
        return -1;
      }
    });
    locations.forEach(function (obj) {
      formattedLocations.push({ value: obj.id, displayValue: obj.locationName })
    });
    return formattedLocations;
  }

  state = {
    loading: false,
    tripForm: {
      dispatcher: this.createInputConfig(
        'datalist',
        {
          options: [],
          list: 'dispatcher',
          labelClass: classes.LabelInline
        },
        'Диспетчер: ',
        '',
        {},
        true,
        null,
        (ev) => this.getUsers(ev)),
      note: this.createInputConfig(
        'textarea',
        { placeholder: 'Коментар...' },
        'Коментар: ',
        '',
        { required: false }),
      tripPoints: this.createInputConfig(
        'trip-points',
        {
          options: [
            ...this.createLocations()
          ],
          animate: 0,
          labelClass: classes.LabelInline,
          buttonImgSrc: routeIconImg
        },
        '',
        [],
        {},
        true,
        null,
        {
          addPoint: (ev) => this.addTripPoint(ev),
          moveUp: (ev, index) => this.moveTripPointUp(ev, index),
          moveDown: (ev, index) => this.moveTripPointDown(ev, index),
          deletePoint: (ev, index) => this.deleteTripPoint(ev, index)
        }
      ),
      tripDate: this.createInputConfig(
        'input',
        {
          type: 'date',
          animate: 0
        },
        'Дата: ',
        this.getTodayDate(),
        { required: true, type: 'date' },
        true,
        classes.InlineTriple),
      priority: this.createInputConfig(
        'select',
        {
          options: [
            { value: 'П1', displayValue: 'П1' },
            { value: 'П2', displayValue: 'П2' },
            { value: 'П3', displayValue: 'П3' }
          ]
        },
        'Пріоритет: ',
        'П3',
        { required: true },
        true,
        classes.InlineTriple),
      capacity: this.createInputConfig(
        'input',
        { type: 'number', step: "0.01", min: "0", placeholder: "0" },
        'Вага (тонн): ',
        0,
        { required: true },
        true,
        classes.InlineTriple),
      price: this.createInputConfig(
        'input',
        { type: 'number', step: "0.01", min: "0", placeholder: "0" },
        'Ціна (грн): ',
        0,
        { required: true },
        true,
        classes.InlineTriple),
      priceComment: this.createInputConfig(
        'input',
        { type: 'text', maxLength: '30' },
        'Ціна Коментар: ',
        '',
        { required: true },
        true,
        classes.InlineTriple),
      priceConfirmed: this.createInputConfig(
        'toggle-switch',
        {},
        'Підтверджена: ',
        false,
        { required: false },
        true,
        classes.InlineTriple),
      carrier: this.createInputConfig(
        'input-search',
        {
          options: []
        },
        'Перевізник: ',
        '',
        { required: false },
        true,
        classes.InlineInput,
        (ev) => this.getCarriers(ev)),
      carrierConfirmed: this.createInputConfig(
        'toggle-switch',
        {},
        'Перевізник підтверджений: ',
        0,
        { required: true },
        true,
        classes.InlineInput),
      car: this.createInputConfig(
        'cars',
        {
          options: []
        },
        'Машина: ',
        null,
        { required: false },
        true,
        classes.InlineInput,
        (ev) => this.createCars(ev)),
      driver: this.createInputConfig(
        'drivers',
        {
          options: []
        },
        'Водій: ',
        null,
        { required: false },
        true,
        classes.InlineInput,
        (ev) => this.createDrivers(ev))
    },
    formIsValid: false
  }

  addTripPoint(ev) {
    ev.preventDefault();
    const updatedForm = { ...this.state.tripForm };
    const locations = Object.keys(this.props.locations);
    if (locations.length > 0) {
      updatedForm.tripPoints.value.push({
        id: -1,
        tripId: -1,
        location: this.props.locations[locations[0]]
      }
      );
      updatedForm.tripPoints.animated = updatedForm.tripPoints.animated + 1;
      this.setState({ tripForm: updatedForm });
    } else {
      this.props.addNotification("Не можна додати точку маршруту: немає локацій.", "Danger");
    }
  }

  deleteTripPoint(ev, index) {
    ev.preventDefault();
    const updatedForm = { ...this.state.tripForm };
    updatedForm.tripPoints.value.splice(index, 1);
    updatedForm.tripPoints.animated = updatedForm.tripPoints.animated + 1;
    this.setState({ tripForm: updatedForm });
  }

  moveTripPointUp(ev, index) {
    ev.preventDefault();
    if (index > 0) {
      const updatedForm = { ...this.state.tripForm };
      const prevPoint = { ...updatedForm.tripPoints.value[index - 1] };
      const currPoint = { ...updatedForm.tripPoints.value[index] };
      updatedForm.tripPoints.value[index - 1] = { ...currPoint, id: prevPoint.id };
      updatedForm.tripPoints.value[index] = { ...prevPoint, id: currPoint.id };
      updatedForm.tripPoints.animated = updatedForm.tripPoints.animated + 1;
      this.setState({ tripForm: updatedForm });
    }
  }

  moveTripPointDown(ev, index) {
    ev.preventDefault();
    if (index < this.state.tripForm.tripPoints.value.length - 1) {
      const updatedForm = { ...this.state.tripForm };
      const nextPoint = { ...updatedForm.tripPoints.value[index + 1] };
      const currPoint = { ...updatedForm.tripPoints.value[index] };
      updatedForm.tripPoints.value[index + 1] = { ...currPoint, id: nextPoint.id };
      updatedForm.tripPoints.value[index] = { ...nextPoint, id: currPoint.id };
      updatedForm.tripPoints.animated = updatedForm.tripPoints.animated + 1;
      this.setState({ tripForm: updatedForm });
    }
  }

  updateLoading = (attr, loading) => {
    const updatedCarriers = { ...this.state.tripForm };
    updatedCarriers[attr].loading = loading;
    this.setState({ cardForm: updatedCarriers });
  }

  getCarriers() {
    if (this.state.tripForm.car.loading) {
      return;
    }

    this.updateLoading("carrier", true);
    axios({
      method: 'get',
      url: '/api/v1/carriers',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        this.updateLoading("carrier", false);
        if (this.props.carriers.length !== response.data.length) {
          const carriers = [...response.data];
          let negId = -1;
          for (let i = 0; i < carriers.length; i++) {
            if (!carriers[i].id) {
              carriers[i].id = negId;
              negId -= 1;
            }
          }
          this.props.onSetCarriers(carriers);
        }
      })
      .catch(error => {
        this.updateLoading("carrier", false);
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Сервер не відповідає.", "Danger");
        }
      });
  }

  getUsers() {
    if (this.state.tripForm.car.loading) {
      return;
    }

    this.updateLoading("dispatcher", true);
    axios({
      method: 'get',
      url: '/api/v1/users',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        this.updateLoading("dispatcher", false);
        if (this.props.users.length !== response.data.length) {
          let parsedUsers = [];
          for (let i = 0; i < response.data.length; i++) {
            parsedUsers.push(response.data[i].substring(0, response.data[i].indexOf('@')));
          }
          this.props.onSetUsers(parsedUsers);
        }
      })
      .catch(error => {
        this.updateLoading("dispatcher", false);
        console.log(error.response);
        if (error.response && error.response.status === 401) {
          this.getUsers();
        } else if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/users'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Помилка на сервері.", "Danger");
        }
      });
  }

  createCars() {
    if (this.state.tripForm.car.loading) {
      return;
    }

    this.updateLoading("car", true);
    if (this.props.cars.length === 0) {
      axios({
        method: 'get',
        url: '/api/v1/cars',
        headers: { 'Authorization': 'Bearer ' + this.props.access_token },
      })
        .then(response => {
          this.updateLoading("car", false);
          this.props.onSetCars(response.data);
        })
        .catch(error => {
          this.updateLoading("car", false);
          console.log(error.response);
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/cars'
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          } else if (!error.response) {
            this.props.addNotification("Помилка на сервері.", "Danger");
          }
        });
    }
  }

  createDrivers() {
    if (this.state.tripForm.car.loading) {
      return;
    }

    this.updateLoading("driver", true);
    if (this.props.drivers.length === 0) {
      const cardForm = this.state.cardForm;
      axios({
        method: 'get',
        url: '/api/v1/drivers',
        headers: { 'Authorization': 'Bearer ' + this.props.access_token },
      })
        .then(response => {
          this.updateLoading("driver", false);
          this.props.onSetDrivers(response.data);
        })
        .catch(error => {
          this.updateLoading("driver", false);
          console.log(error.response);
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/drivers'
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          } else if (!error.response) {
            this.props.addNotification("Помилка на сервері.", "Danger");
          }
        });
    }
  }

  getAttribute(carrier, attr) {
    if (carrier[attr]) {
      return carrier[attr];
    }
    return "";
  }

  createDispatchers() {
    let dispatchers = [];
    dispatchers.push({ value: "-", displayValue: "-" });
    for (let i = 0; i < this.props.users.length; i++) {
      dispatchers.push({
        value: this.props.users[i],
        displayValue: this.props.users[i]
      });
    }
    return dispatchers;
  }

  createCarriers() {
    let carriers = [];
    carriers.push({ value: "-", displayValue: "-" });
    for (let i = 0; i < this.props.carriers.length; i++) {
      let carrier = this.props.carriers[i];
      let carrierName = carrier.id <= 0 ? "" : carrier.id + " | ";
      carrierName += this.getAttribute(carrier, "okpo") + " | ";
      carrierName += this.getAttribute(carrier, "name") + " | ";
      carrierName += this.getAttribute(carrier, "name_partner") + " | ";
      carrierName += this.getAttribute(carrier, "name_ls");
      carriers.push({
        value: carrier.id,
        displayValue: carrierName
      });
    }
    return carriers;
  }

  createManagers() {
    return this.props.managers.map((manager, index) => {
      return (
        { value: manager.name, displayValue: manager.name }
      )
    });
  }

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.props.closeCard();
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  compareDisplayValue = (a, b) => {
    if (a.displayValue > b.displayValue) {
      return 1;
    } else if (a.displayValue < b.displayValue) {
      return -1;
    }
    return 0;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.carriers.length !== this.props.carriers.length) {
      const updatedTripForm = { ...this.state.tripForm };
      updatedTripForm.carrier.elementConfig.options = this.createCarriers().sort(this.compareDisplayValue);
      this.setState({ tripForm: updatedTripForm });
    }

    if (prevProps.locations !== this.props.locations) {
      const updatedTripForm = { ...this.state.tripForm };
      updatedTripForm.tripPoints.elementConfig.options = [...this.createLocations()];
      const locations = Object.keys(this.props.locations);
      if (locations.length > 0) {
        updatedTripForm.tripPoints.value = [
          {
            id: -1,
            tripId: -1,
            location: this.props.locations[locations[0]]
          },
          {
            id: -1,
            tripId: -1,
            location: this.props.locations[locations[0]]
          }
        ];
        this.setState({ tripForm: updatedTripForm });
      } else {
        this.props.addNotification("Не можна додати точку маршруту: немає локацій.", "Danger");
      }
    }

    if (this.props.cars !== prevProps.cars) {
      let cars = [{ value: "-", displayValue: "-" }];
      let foundCar = false;
      for (let i = 0; i < this.props.cars.length; i++) {
        if (this.props.cars[i].name === this.state.tripForm.car.value) {
          foundCar = true;
        }
        cars.push({
          value: this.props.cars[i].name,
          displayValue: this.props.cars[i].name
        });
      }
      if (!foundCar && this.state.tripForm.car.value !== "-") {
        cars.push({
          value: this.state.tripForm.car.value,
          displayValue: this.state.tripForm.car.value
        });
      }
      const cardForm = { ...this.state.tripForm };
      cardForm.car.elementConfig.options = cars.sort(this.compareDisplayValue);
      this.setState({ loading: false, tripForm: cardForm });
    }

    if (this.props.drivers !== prevProps.drivers) {
      let drivers = [{ value: "-", displayValue: "-" }];
      for (let i = 0; i < this.props.drivers.length; i++) {
        drivers.push({
          value: this.props.drivers[i].id,
          displayValue: this.props.drivers[i].name
        });
      }
      const cardForm = { ...this.state.tripForm };
      cardForm.driver.elementConfig.options = drivers.sort(this.compareDisplayValue);
      this.setState({ loading: false, tripForm: cardForm });
    }

    if (prevProps.users !== this.props.users) {
      const updatedCardForm = { ...this.state.tripForm };
      updatedCardForm.dispatcher.elementConfig.options = this.createDispatchers().sort(this.compareDisplayValue);
      this.setState({ tripForm: updatedCardForm });
    }

    if (!prevProps.origin && this.props.origin) {
      console.log("Location: " + this.props.origin);
      if (this.props.origin in this.props.locations) {
        const updatedForm = { ...this.state.tripForm };
        const updatedTripPoints = [...updatedForm.tripPoints.value];
        updatedTripPoints[0] = {
          id: -1,
          tripId: -1,
          location: this.props.locations[this.props.origin]
        };
        updatedForm.tripPoints.value = updatedTripPoints;
        console.log("Updating to: ", this.props.locations[this.props.origin]);
        this.setState({ tripForm: updatedForm });
      }
    }

    if (!prevProps.destination && this.props.destination) {
      console.log("Location: " + this.props.destination);
      if (this.props.destination in this.props.locations) {
        const updatedForm = { ...this.state.tripForm };
        const updatedTripPoints = [...updatedForm.tripPoints.value];
        updatedTripPoints[1] = {
          id: -1,
          tripId: -1,
          location: this.props.locations[this.props.destination]
        };
        updatedForm.tripPoints.value = updatedTripPoints;
        console.log("Updating to: ", this.props.locations[this.props.destination]);
        this.setState({ tripForm: updatedForm });
      }
    }
  }

  checkValidity(value, rules) {
    let isValid = true;

    if (rules.required) {
      isValid = value.trim !== '' && isValid;
    }

    if (rules.type === "email") {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isValid = re.test(value) && isValid;
    }

    if (rules.type === "confirmPassword") {
      isValid = this.state.registerForm.password.value === value && isValid;
    }

    if (rules.minLength) {
      isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
    }

    return isValid;
  }

  getErrorMessage(value, rules) {
    let errorMessage = '';

    if (rules.required && value.trim === '') {
      errorMessage = 'Це поле обов\'язкове';
    }

    if (rules.type == 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(value)) {
        errorMessage = 'Введіть пошту';
      }
    }

    if (rules.type === "confirmPassword" && this.state.registerForm.password.value !== value) {
      errorMessage = 'Паролі повинні співпадати';
    }

    if (rules.minLength && value.length < rules.minLength) {
      errorMessage = 'Мінімальна довжина: ' + rules.minLength;
    }

    if (rules.maxLength && value.length > rules.maxLength) {
      errorMessage = 'Максимальна довжина: ' + rules.minLength;
    }

    return errorMessage;
  }

  inputChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.tripForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    if ((event.target.value === '' || event.target.value === null) &&
      updatedOrderForm[elementId].elementConfig.type === 'number') {
      event.target.value = 0;
    }
    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
      updatedFormElement.validation);
    updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
      updatedFormElement.validation);
    updatedOrderForm[elementId] = updatedFormElement;
    let capacityFilled = null;

    let formIsValid = true;
    for (let inputIdentifier in updatedOrderForm) {
      formIsValid = updatedOrderForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({ tripForm: updatedOrderForm, formIsValid: formIsValid });
  }

  newTripHandler = (event) => {
    event.preventDefault();
    if (this.props.access_token === null) {
      return;
    }

    let date = Date.parse(this.state.tripForm.tripDate.value);
    date = new Date(date);
    let dateStr = date.getFullYear() + "-";
    if ((date.getMonth() + 1) < 10) {
      dateStr += "0";
    }
    dateStr += (date.getMonth() + 1) + "-";
    if (date.getDate() < 10) {
      dateStr += "0";
    }
    dateStr += date.getDate();
    const data = {
      tripDate: dateStr,
      tripPoints: this.state.tripForm.tripPoints.value,
      priority: this.state.tripForm.priority.value,
      capacity: this.state.tripForm.capacity.value,
      price: this.state.tripForm.price.value,
      priceComment: this.state.tripForm.priceComment.value,
      priceConfirmed: this.state.tripForm.priceConfirmed.value,
      carrierId: this.state.tripForm.carrier.value,
      carrierConfirmed: this.state.tripForm.carrierConfirmed.value,
      car: this.state.tripForm.car.value,
      dispatcher: this.state.tripForm.dispatcher.value,
      driver: this.state.tripForm.driver.value,
      note: this.state.tripForm.note.value
    }

    axios({
      method: 'post',
      url: '/api/v1/trips',
      data: data,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.access_token
      },
    })
      .then(response => {
        console.log(response);
        this.props.addNotification("Рейс був успішно створений.", "Success");
        this.onRouteCreatedHandler(response.data);
        this.props.closeCard();
      })
      .catch(error => {
        console.log(error);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/trips'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Сервер не відповідає.", "Danger");
        }
        this.setState({ loading: false });
      });
  }

  onRouteCreatedHandler(route) {
    const updatedRoutes = [...this.props.routes];
    updatedRoutes.push(route);
    this.props.onSetRoutes(updatedRoutes);
  }

  render() {
    let card = null;

    const tripFormArray = [];
    for (let key in this.state.tripForm) {
      tripFormArray.push({ id: key, config: this.state.tripForm[key] });
    }

    card = (
      <Aux>
        <div className={classes.Header}>
          <Icon iconClass={classes.CarIcon} iconSource={carImg} iconAlt='' className={classes.CardIcon} />
          <p>Новий Рейс</p>

          <button className={classes.CloseButton} onClick={this.props.closeCard}>
            <Icon iconClass={classes.CloseIcon} iconSource={closeImg} iconAlt='' />
          </button>
          <p style={{ height: "100%" }}></p>
        </div>

        <form className={classes.NewTripForm} onSubmit={this.newTripHandler}>
          <div className={classes.Body} >
            {tripFormArray.map(formElement => {
              return (
                <Input
                  key={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  extraClass={formElement.config.extraClass}
                  extraAction={formElement.config.extraAction}
                  changed={(event) => this.inputChangedHandler(event, formElement.id)} />
              );
            })}
          </div>

          <div className={classes.Footer}>
            <ButtonIcon
              btnType='Success'
              iconClass={classes.ButtonIcon}
              iconSource={saveImg}
              iconAlt=''>СТВОРИТИ РЕЙС</ButtonIcon>
          </div>
        </form>
      </Aux>
    );

    return (
      <Aux>
        <Backdrop show={this.props.show} clicked={this.props.closeCard} />
        <div
          className={classes.CardModal}
          style={{
            transform: this.props.show ? 'translateY(0)' : 'translateY(-100vh)',
            opacity: this.props.show ? '1' : '0'
          }}>
          {card}
        </div>
      </Aux>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    notifications: state.notifications,
    carriers: state.carriers,
    managers: state.managers,
    drivers: state.drivers,
    cars: state.cars,
    users: state.users,
    routes: state.routes,
    origin: state.origin,
    destination: state.destination,
    locations: state.locations,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({
      type: actionTypes.ADD_NOTIFICATION,
      notification: notification,
      notificationType: notificationType
    }),
    onSetCarriers: (carriers) => dispatch({
      type: actionTypes.SET_CARRIERS,
      carriers: carriers
    }),
    onSetUsers: (users) => dispatch({
      type: actionTypes.SET_USERS,
      users: users
    }),
    onSetCars: (cars) => dispatch({
      type: actionTypes.SET_CARS,
      cars: cars
    }),
    onSetDrivers: (drivers) => dispatch({
      type: actionTypes.SET_DRIVERS,
      drivers: drivers
    }),
    onSetRoutes: (routes) => dispatch({
      type: actionTypes.ROUTES,
      routes: routes
    }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CardModal);



// WEBPACK FOOTER //
// ./src/components/UI/NewTrip/NewTrip.js